import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import log from "../../../../util/log";
import sapi from "../../../../util/sapi";
import c from '../../../../util/const'
import sharedActions from "../../../../actions/shared-actions"
import {Account} from "../../../pages/Account";
import Promise from "bluebird";
import {withVFTranslation} from "../../../../util/withVFTranslation";
import _ from "lodash";
import Image from "../../elements/Image";
import api from "../../../../util/api";
import withVfRouting from "../../../../util/withVFRouting";

class InformationServicesCtrl extends Component {

  constructor(props) {
    super(props);

    this.state = {
      publisherLogos : {},
      publisherSubscriptions : {}
    }
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(undefined);
    }
  }

  init() {
    this.props.updatePublisherList().then(() => this.rebuildPublisherState())

    // sapi.Contacts.list()
    //   .then((res) => {
    //     log.log('GOT CONTACTS LIST', res)
    //   })
  }

  rebuildPublisherState(){
    let { publisherList } = this.props;

    //local state, not populated if we can't get a logo.
    let publisherLogos = {};
    let publisherSubscriptions = {};

    let promises = [];
    _.each(publisherList, (p) => {
      promises.push(
        this.fetchLogo(p.uid)
          .then((dataUrl) => {
            if(dataUrl){
              publisherSubscriptions[p.uid] = p.subscribed_flag;
              publisherLogos[p.uid] = dataUrl;
            }
          })
      );
    })

    Promise.all(promises)
      .then((res) => {
        this.setState({
          publisherLogos,
          publisherSubscriptions
        })
      })
  }

  fetchLogo(uid){
    return new Promise((resolve, reject) => {
      if(this.state.publisherLogos[uid]){
        resolve(this.state.publisherLogos[uid]);
        return;
      }

      api.AcctLogo.logo(uid)
        .then((res) => {
          log.log('got logo', res);
          let dataUrl = _.get(res, 'data.logo');
          resolve(dataUrl);
        })
        .catch((err) => {
          log.log('error fetching logo', err);
          resolve(null);
        })
    })
  }

  updateIsSubscribed(uid, isSubscribed){
    let copy = _.extend({}, this.state.publisherSubscriptions);
    copy[uid] = isSubscribed;
    this.setState({publisherSubscriptions: copy});
  }

  togglePublisher(uid, evt){
    this.updateIsSubscribed(uid, evt.target.checked);

    let promise = null;
    if(evt.target.checked){
      promise = sapi.Contacts.subscribePublisher(uid);
    }
    else{
      promise = sapi.Contacts.unsubscribePublisher(uid);
    }

    promise
      .then((res) => {
        log.log('change subscribe success', res);
        this.props.updatePublisherList().then(() => this.rebuildPublisherState())
      })
      .catch((err) => {
        log.log('error changing subscribe status', err);
        this.props.updatePublisherList().then(() => this.rebuildPublisherState())
      })
  }

  renderPublisher(publisher){
    let { t } = this.props;
    let {
      publisherLogos,
      publisherSubscriptions
    } = this.state;
    let logo = publisherLogos[publisher.uid];
    let isSubscribed = !!(publisherSubscriptions[publisher.uid]);

    return (
      <div className="d-flex mb-3">
        <div className="ms-3 me-2">
          <span className="form-check form-switch form-switch-lg justify-content-end d-flex pe-2">
            <input className="form-check-input"
                   type="checkbox"
                   role="switch"
                   onChange={(evt) => this.togglePublisher(publisher.uid, evt)}
                   checked={isSubscribed}
                   id={`is-subscribed-checkbox-${publisher.uid}`}/>
            <label className="form-check-label" htmlFor={`is-subscribed-checkbox-${publisher.uid}`} />
          </span>
        </div>
        <div>
          <Image src={logo || c.BLANK_LOGO}
                 alt={t('Logo')}
                 imgHeight={50}/>
          <h6 style={{marginTop: '5px'}} className="mb-0 fw-bold">
            {publisher.title}
          </h6>
          <p>
            {publisher.description}
          </p>
        </div>

      </div>
    )
  }

  render() {
    let { publisherList } = this.props;
    return (
      <div style={Account.styles.wideRowContents} className={'mt-3 mb-3'}>

        <div className="row">
          {publisherList && _.map(publisherList, (publisher) => {
            return (
              <div key={publisher.uid} className="col-6">
                {this.renderPublisher(publisher)}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

InformationServicesCtrl.propTypes = {
  doClose: PropTypes.func.isRequired,
  onRef: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    accountInfo: state.shared.accountInfo,
    publisherList: state.shared.publisherList
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...sharedActions.mapToDispatch(dispatch)
  };
};
export default withVFTranslation()(withVfRouting(connect(mapStateToProps, mapDispatchToProps)(InformationServicesCtrl)));
